module.exports = __webpack_public_path__ + "static/media/article-dummy-1.f65765b5.png";